import React, { useState } from "react";
import {
  HeaderWrapper,
  Container,
  Logo,
  NavLinks,
  JoinButton,
  Hamburger
} from "./header.styled";
import { Link, useLocation } from "react-router-dom";

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(prev => !prev);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <HeaderWrapper>
      <Container>
        <Hamburger onClick={toggleMenu} aria-label="Toggle menu">
          ☰
        </Hamburger>

      
          <Link
            to="/home" >
                    <Logo>
                      <img src="/assets/dtdl/logo.svg" alt="DT Digital Labs Logo" />
                    </Logo>

            </Link>
            
         

        <NavLinks className={isMenuOpen ? "active" : ""}>
        {isMenuOpen && <span className="close-icon" onClick={toggleMenu}>✕</span>}

          <Link
            to="/dtdl-tech"
            className={location.pathname === "/dtdl-tech" ? "active" : ""}
            onClick={closeMenu}
          >
            Tech@DTDL
          </Link>
          <Link
            to="/dtdl-life"
            className={location.pathname === "/dtdl-life" ? "active" : ""}
            onClick={closeMenu}
          >
            Life@DTDL
          </Link>
          <Link
            to="/blogs"
            className={location.pathname === "/blogs" ? "active" : ""}
            onClick={closeMenu}
          >
            Blogs & News
          </Link>
        </NavLinks>

        <JoinButton>
         <Link to="/joinus" >
          <button>
             Join Us
          </button>
         </Link>
        </JoinButton>
      </Container>
    </HeaderWrapper>
  );
};

export default Header;
